module.exports = __webpack_public_path__ + "static/media/SF-21-A (1).4f73bc3d.mp3";